import {
  FETCH_INVENTORYSUMMERY_REQUEST,
  FETCH_INVENTORYSUMMERY_SUCCESS,
  FETCH_INVENTORYSUMMERY_FAILURE,
} from "./inventorysummeryTypes";

const initialState = {
  loading: false,
  inventorysummaryData: [],
  error: "",
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_INVENTORYSUMMERY_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case FETCH_INVENTORYSUMMERY_SUCCESS:
      return {
        loading: false,
        inventorysummaryData: action.payload,
        error: "",
      };
    case FETCH_INVENTORYSUMMERY_FAILURE:
      return {
        loading: false,
        inventorysummaryData: [],
        error: action.payload,
      };
    default:
      return state;
  }
};

export default reducer;
